module.exports = "/images/vendor/flag-icon-css/flags/1x1/cy.svg?9f04989a23400aa64e7a7ac053f32963";